// extracted by mini-css-extract-plugin
export default {"body":"AnatomyFigure_body__6jUhg","muscle":"AnatomyFigure_muscle__8G6pj"};